'use client';

import * as React from 'react';
import { AppBar, Box, Toolbar } from '@mui/material';
import Theme from '../components/Theme';

export default function RootLayout({
  children,
}: {
  children: React.ReactNode;
}) {
  return (
    <html lang='en'>
      <body>
        <Theme>
          <Box
            sx={{
              minHeight: '100vh',
              display: 'flex',
              flexDirection: 'column',
            }}
          >
            <AppBar
              position='fixed'
              sx={{
                zIndex: (t) => t.zIndex.drawer + 1,
                backgroundColor: '#f7f4f2',
                boxShadow: 'none',
                borderBottom: 'none',
                height: 85,
              }}
            >
              <Toolbar
                disableGutters
                sx={{
                  height: 85,
                  minHeight: 85,
                  borderBottom: 'none',
                  boxShadow: 'none',
                }}
              >
                <Box
                  sx={{ display: 'flex', alignItems: 'flex-start', pl: '12px' }}
                >
                  <a href='https://argos.fastcomputing.net'>
                    <img
                      src='https://argos.fastcomputing.net/static/images/logo-argos.png'
                      alt='ARGOS logo'
                      style={{
                        height: '40px',
                        width: 'auto',
                        display: 'block',
                        marginLeft: '15vw',
                      }}
                    />
                  </a>
                </Box>
              </Toolbar>
            </AppBar>

            {/* Spacer so content starts below fixed AppBar */}
            <Toolbar sx={{ height: 85, minHeight: 85 }} />

            {/* Scrollable content area */}
            <Box
              component='main'
              sx={{ flex: 1, minHeight: 0, overflow: 'hidden' }}
            >
              {children}
            </Box>
          </Box>
        </Theme>
      </body>
    </html>
  );
}
